import { render, staticRenderFns } from "./CallSheetWithSubjectsAllMange.vue?vue&type=template&id=472471d6&scoped=true"
import script from "./CallSheetWithSubjectsAllMange.vue?vue&type=script&lang=js"
export * from "./CallSheetWithSubjectsAllMange.vue?vue&type=script&lang=js"
import style0 from "./CallSheetWithSubjectsAllMange.vue?vue&type=style&index=0&id=472471d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472471d6",
  null
  
)

export default component.exports